import { render, staticRenderFns } from "./SkillsTableRowProfession.vue?vue&type=template&id=ff003856&scoped=true&"
import script from "./SkillsTableRowProfession.vue?vue&type=script&lang=js&"
export * from "./SkillsTableRowProfession.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff003856",
  null
  
)

export default component.exports